import * as type from './types';

export function buyProjectData(data) {
    return {
        type: type.GET_ALL_BUY_PROJECTS_DATA_REQUESTED,
        data: data,
    }
}